export default {
  apiGetAllEvents(urldata = {}) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().getAllEvents)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((res) => {
        return res;
      })
      .get();
  },
  apiGetSingleEvent(urldata = {}) {
    urldata = { ...urldata };
    return this.request(this.api().getSingleEventById)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((res) => {
        return res;
      })
      .get();
  },
  apiCreateEventSuper(data) {
    return this.request(this.api().createEventSuper, data).exec().log().get();
  },
  apiDeleteEventSuper(urldata = {}, data) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().deleteEventSuper, data)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
  apiUpdateEventSuper(urldata = {}, data) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().updateEventSuper, data)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
  apiGetAccessedSessions(urldata) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().getAllAccessedSessions)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((res) => {
        return res;
      })
      .get();
  },
  apiGetTodaysEventsBySchoolId(urldata,data) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().getTodaysEvents,data)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((res) => {
        return res;
      })
      .get();
  },
  apiGetMonthlyEventsBySchoolId(urldata,data) {
    urldata = { ...mixins.params(), ...urldata };
    return this.request(this.api().getMonthlyEvents,data)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((res) => {
        return res;
      })
      .get();
  },
};